import moment from "moment-timezone";

export const blockedIpTable = (data) => {
    return (
        data &&
        data.length &&
        data.map((item, index) => {
            const {
                account_name,
                campaign_name,
                ip,
                block_reason,
                created_at,
                country_code,
                country_name,
                click_id,
                initial_click_id,
            } = item;

            return {
                rowId: index + 1,
                created_at,
                ip,
                block_reason,
                account_name,
                campaign_name,
                country_code: country_code.toUpperCase(),
                country_name,
                click_id,
                initial_click_id,
            };
        })
    );
};
